import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../actions'
import { IBonusSystemState } from '../types'

const initialState: IBonusSystemState['data'] = {
  promotionsPoliing: {
    count: 0,
    page: 1,
    promos: [],
  },
  promotions: {
    count: 0,
    page: 1,
    promos: [],
  },
}
export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getUserPromotions.reset, (state, action) => {
      state.promotions = initialState.promotions
    })
    .addCase(actions.getUserPromotions.success, (state, action) => {
      state.promotions = action.payload
    })
    .addCase(actions.getMoneyFromPromotion.success, (state, action) => {
      state.promotions.promos = state.promotions.promos.map(card =>
        String(card.id) === action.payload.id ? action.payload.data : card,
      )
      state.promotionsPoliing.promos = state.promotionsPoliing.promos.map(card =>
        String(card.id) === action.payload.id ? action.payload.data : card,
      )
    })
    .addCase(actions.getUserPromotionsPoll.success, (state, action) => {
      state.promotionsPoliing = action.payload
    })
})
